import type { OptionsDocument } from 'paintscout'
import type { ReviewRequestMessage } from '../..'

export function getReviewRequestMessage(args: { options: OptionsDocument }): ReviewRequestMessage {
  const { options } = args
  return {
    message: options.options.reviewRequestMessage?.message ?? '',
    link: options.options.reviewRequestMessage?.link ?? ''
  }
}
